<template>
  <ul>
    <li
      v-for="(example, index) in createFlowExamples"
      :key="index"
      class="border-t-1 border-solid border-grey-divider-subdued py-16 select-none"
    >
      <h3 class="text-h4 mb-4">{{ example.title }}</h3>
      <span class="flex items-center mb-8">
        <TickIcon color="#FF0064" aria-hidden="true" class="mr-8" />
        <p class="text-body text-grey-text-subdued">{{ example.category }}</p>
      </span>
      <p class="text-body">{{ example.passion }}</p>
    </li>
  </ul>
</template>

<script lang="ts">
import TickIcon from '@/graphics/icons/TickIcon.vue';
import { createFlowExamples } from '@/helpers/exampleAdventures';

export default {
  name: 'PassionExamples',
  components: { TickIcon },
  data() {
    return {
      createFlowExamples,
    };
  },
};
</script>
